<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="Q" :title="title"></SectionTitle>
    <QuestionBox :title="questionTitle" :desc="questionDesc" :items="questionItem" v-on:selected="selected" :index="questionAnswer" ></QuestionBox>
    <GoNext class="animate-target" v-animate-in href="/section5/5-4" :selected="selectedValue" required="true"></GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt" />
  </div>
</template>

<script>

import SectionTitle from "../../components/SectionTitle";
import QuestionBox from "../../components/QuestionBox";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s5-3",
  components: {SectionTitle, QuestionBox, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return {
      questionTitle: "Question 3",
      questionDesc: "In addition to blood glucose and blood pressure control, the guideline-recommended treatments with additional CV and renal protective benefits in patients with T2D and CKD are:<sup>1,2</sup>",
      questionItem:[
          "SGLT2i, ACEi/ARB, nsMRA",
          "GLP-1 RA, SGLT2i, ACE/ARB",
          "ACEi/ARB, SGLT2i, nsMRA, GLP-1 RA",
          "GLP-1 RA, ACEi/ARB, nsMRA"
      ],
      selectedValue:'',
      questionAnswer:'2',
      noticeTxt:"ACEi, angiotensin converting enzyme inhibitor; ARB, Angiotensin receptor blocker; CKD, chronic kidney disease; CV, cardiovascular disease; GLP-1 RA, glucagon-like peptide-1 receptor agonist; nsMRA, nonsteroidal mineralocorticoid receptor antagonist; RAS, Renin angiotensin system; SGLT 2 sodium-glucose co transporter 2; T2D, type 2 diabetes.<br/><div class='brs'></div>"
      +"Reference:<br/><div class='brs'></div>"
      +"1. KDIGO Diabetes Work Group. Kidney International (2022) 102 (Suppl 5S), S1–S127.<br/>"
      +"2. RACGP. Management of type 2 diabetes: A handbook for general practice. <a target='_blank' class='c-url' href='https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx'>https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx</a>.",
      title:"Post-activity quiz"
    };
  },
  methods:{
    selected:function(value){
      this.selectedValue = value;
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section5/s5.css";
</style>
